import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClientProvider} from '@tanstack/react-query';
import {queryClient} from './query/queryClient';
import {installCurrentUserQueryListener} from './query/currentUserQuery';
import {installGatewayConnectionStateQueryListener} from './query/gatewayConnectionStateQuery';
import {installBuildingStateQueryListeners} from './query/buildingStateQuery';
import {initializeGoogleLogin} from './client/IWGoogleAuth';

installCurrentUserQueryListener(queryClient);
installGatewayConnectionStateQueryListener(queryClient);
installBuildingStateQueryListeners(queryClient);
initializeGoogleLogin().catch(error => {
  console.warn('(index) Google Login initialization failed', error);
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
